import { createSlice, type PayloadAction } from "@reduxjs/toolkit"
import type { RootState } from "store"
import type { ILesson } from "types/lessonTypes"

interface LessonState {
  lessons: Array<ILesson>
  currentLesson: ILesson | undefined
}

const initialState: LessonState = {
  lessons: [] as ILesson[],
  currentLesson: undefined,
}

export const lessonSlice = createSlice({
  name: "lesson",
  initialState,
  reducers: {
    setLessons: (state, action: PayloadAction<Array<ILesson>>) => {
      state.lessons = action.payload
    },
    setCurrentLesson: (state, action: PayloadAction<ILesson>) => {
      state.currentLesson = action.payload
    },
    addLesson: (state, action: PayloadAction<ILesson>) => {
      state.lessons?.push(action.payload)
    },
    updateLesson: (state, action: PayloadAction<ILesson>) => {
      var index = state.lessons.findIndex((x) => x.id === action.payload.id)

      if (index !== -1) {
        state.lessons[index] = action.payload
      }
    },
    removeLesson: (state, action: PayloadAction<ILesson>) => {
      var index = state.lessons.findIndex((x) => x.id === action.payload.id)

      if (index !== -1) {
        state.lessons.splice(index, 1)
      }
    },
    resetLesson: (state, _action) => {
      state.lessons = []
      state.currentLesson = undefined
    },
  },
})

export const { setLessons, addLesson, updateLesson, removeLesson, setCurrentLesson, resetLesson } =
  lessonSlice.actions

// Other code such as selectors can use the imported `RootState` type
export const selectCount = (state: RootState) => state.lesson

export default lessonSlice.reducer
